import { useEffect, useRef } from 'react';
import type { ForwardedRef } from 'react';
// This code is borrowed from:
// https://github.com/facebook/react/issues/24722
export function useForwardRef<T>(ref: ForwardedRef<T>, initialValue: T | null = null) {
  const targetRef = useRef<T | null>(initialValue);

  useEffect(() => {
    if (!ref) return;

    if (typeof ref === 'function') {
      ref(targetRef.current);
    } else {
      ref.current = targetRef.current;
    }
  }, [ref]);

  return targetRef;
}
